/* eslint-disable react/prop-types */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS201: Simplify complex destructure assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import reactUpdate from 'immutability-helper';
import $ from 'jquery';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import type {Permissions} from 'auth/PermissionConstants';
import BufferOptions from 'buffers/BufferOptions';
import BufferOptionsItem from 'buffers/BufferOptionsItem';
import {isBrowser} from 'lib/Browser';
import DocumentManagerComponentClass from 'notebook/mediocre/core-ui/DocumentManagerComponent';
import type {SelectionPartition} from 'notebook/mediocre/EditorTypes';
import FormatState from 'notebook/mediocre/formatted-text/FormatState';
import formatters from 'notebook/mediocre/formatted-text/formatters';
import FormattersConstants, {
  type Format,
  type FormatData,
} from 'notebook/mediocre/formatted-text/FormattersConstants';
import {
  EditLinkModal,
  type EditingLinkState,
  formatText,
  getEditingLinkState,
} from 'notebook/mediocre/formatted-text/FormatTextUtil';
import PositionedLinkPopover from 'notebook/mediocre/hyperlinks/PositionedLinkPopover';
import {isHeadlessChrome, maybeUpdatePrintWarningForContentWidth} from 'notebook/mediocre/print/PrintUtil';
import type {BenchlingSelection, KeyData} from 'notebook/mediocre/selection/SelectionStore';
import SelectionReader, {
  type HyperlinkState,
  type SignState,
} from 'notebook/mediocre/selection/text/SelectionReader';
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';
import InsertSymbolModalClass from 'notebook/mediocre/symbols/InsertSymbolModal';
import StaticFormatToolbarClass from 'notebook/mediocre/toolbars/StaticFormatToolbar';
import IntroEditorClass from 'notebook/protocols/editor/IntroEditor';
import MaterialsEditorClass, {
  type MaterialIndex,
  type MaterialsEditorComponent,
  type MaterialsEditorMaterial,
  type MaterialsEditorProtocol,
} from 'notebook/protocols/editor/MaterialsEditor';
import ProtocolToolbar from 'notebook/protocols/editor/ProtocolToolbar';
import StepsEditorContainer from 'notebook/protocols/editor/StepsEditorContainer';
import type {StepsEditor as StepsEditorInstance} from 'notebook/protocols/editor/StepsEditorTypes';
import TitleEditorClass from 'notebook/protocols/editor/TitleEditor';
import * as MaterialConstants from 'notebook/protocols/MaterialConstants';
import ProtocolStoreTransforms from 'notebook/protocols/ProtocolStoreTransforms';
import * as StepConstants from 'notebook/protocols/StepConstants';
import * as TableConstants from 'notebook/tables/constants/TableConstants';
import * as TableLayoutConstants from 'notebook/tables/constants/TableLayoutConstants';
import * as excessutil from 'notebook/tables/excess/Util';
import notifications from 'notifications';
import DisplayOptions from 'settings/visibility-options/DisplayOptions';
import type {VisibilityOptions} from 'settings/visibility-options/VisibilityOptions';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import IntermediateBinder from 'ui-library/IntermediateBinder';
import ModalAnchor from 'ui-library/ModalAnchor';
import * as logging from 'util/Logging';
import throttle from 'util/throttle';
import type {ElementKeyboardEvent, ElementMouseEvent} from 'util/Types';

const {LEVEL_MATERIAL} = MaterialConstants;
const {DEFAULT_TABLE_SIZE, DEFAULT_PLATE_SIZE} = TableLayoutConstants;
const {TABLE_NAME_WELL_PREFIX} = TableConstants;
const {AGGREGATE_TIME, StepLevel, TYPE_CRITICAL, TYPE_PAUSE, INSERT_SYMBOL, INSERT_WELL_PLATE, EditorKey} =
  StepConstants;
const STEP_FORMATS = [
  StepLevel.HEADER,
  StepLevel.STEP,
  StepLevel.DESC,
  AGGREGATE_TIME,
  TYPE_CRITICAL,
  TYPE_PAUSE,
];

/** Index of a title/intro/steps/materials item as stored on the current selection. */
export type ProtocolEditorItemIndex = number | MaterialIndex;

/** Identifies which nested editor owns a format/symbol operation. */
export interface ProtocolEditorFormatLocation {
  editorKey: StepConstants.EditorKey | string;
  index: ProtocolEditorItemIndex;
}

/**
 * Standalone protocols, entry-embedded protocols, and print views share this editor.
 * Required fields differ across those callers, so the common shape stays optional and
 * the editor uses the same runtime assumptions as the previous JS module.
 */
export interface ProtocolEditorProtocol {
  cid?: string;
  name?: string;
  description?: string;
  descriptionFormats?: Format;
  materials?: Array<MaterialsEditorMaterial>;
  steps?: Array<StepConstants.Step>;
  inEntry?: boolean;
  /** Absent on entry-embedded protocols. */
  permissions?: Pick<Permissions, 'readable'> | null;
  url?: string;
  externalFile?: unknown;
}

export interface ProtocolEditorUpdate {
  name?: string;
  description?: string;
  descriptionFormats?: Format;
  materials?: Array<MaterialsEditorMaterial>;
  steps?: Array<StepConstants.Step>;
}

interface ProtocolEditorSelected {
  editorKey?: StepConstants.EditorKey | string;
  index?: ProtocolEditorItemIndex;
  subIndex?: string;
  hasNonEmptyTextSelection?: boolean;
}

interface ProtocolEditorFormatEvent {
  format: string;
  data?: FormatData;
  partition?: SelectionPartition | null;
}

interface InsertingSymbolState {
  index: ProtocolEditorFormatLocation | ProtocolEditorItemIndex;
  partition: {before: string; after: string; selected: string; afterPoint?: boolean} | null;
  formats: Format;
}

interface ProtocolEditorBinderProps {
  storeState: ProtocolEditor['nestedStoreState'];
  restoreState: ProtocolEditor['nestedRestoreState'];
  requestSelection: ProtocolEditor['nestedRequestSelection'];
  formatHandler: ProtocolEditor['_formatHandler'];
}

export interface ProtocolEditorProps {
  fileId: string;
  protocol: ProtocolEditorProtocol;
  optionsChildren?: React.ReactNode;
  storeState(data: KeyData | {selection: BenchlingSelection | null}): void;
  restoreState(e: ElementKeyboardEvent, data: KeyData | {selection: BenchlingSelection}): boolean | void;
  requestSelection(data: KeyData | {selection: BenchlingSelection | null}): void;
  moreFormats: Array<{
    format: string;
    onClick(initialSelectorId?: string): void;
    tooltip?: Array<string>;
    moreKey?: string;
  }>;
  displayOptions?: VisibilityOptions | null;
  banner?: string | JSX.Element;
  spellCheck: boolean;
  showPrintMargins: boolean;
  printLayout: boolean;
  viewer: boolean;
  showToolbar?: boolean;
  locked?: boolean;
  updateProtocol?(update: ProtocolEditorUpdate, op?: unknown): void;
  metadataForRestore?: KeyData | {selection: BenchlingSelection} | null;
  printOptions?: Array<string>;
  printHandler?(format: string): void;
  openManageSelectorsModal?(id?: string): void;
  revertProtocol?: unknown;
  undoStoreState?: unknown;
}

interface ProtocolEditorState {
  selected: ProtocolEditorSelected;
  atSignState: SignState | null;
  hyperlinkState: HyperlinkState | null;
  formatState: ReturnType<typeof FormatState.readFormats>;
  editorWidth: number;
  showInsertLinkModal: boolean;
  insertingSymbolState: InsertingSymbolState | null;
  containerWidth?: number;
  containerHeight?: number;
  editingLinkState?: EditingLinkState<ProtocolEditorFormatLocation> | null;
  slashSignState?: SignState | null;
  nonEmptySelectionState?: {box: {top: number; left: number; bottom: number}} | null;
  highlightEditorKey?: string | null;
  highlightIndex?: ProtocolEditorItemIndex | null;
  insertEditorKey?: string | null;
  insertIndex?: ProtocolEditorItemIndex | null;
}

class ProtocolEditor extends React.Component<ProtocolEditorProps, ProtocolEditorState> {
  static propTypes = {
    fileId: PropTypes.string.isRequired,
    protocol: PropTypes.shape({
      inEntry: PropTypes.bool,
      // permissions is not specified if inEntry
      permissions: PropTypes.shape({readable: PropTypes.bool.isRequired}),
    }).isRequired,
    optionsChildren: PropTypes.node,
    storeState: PropTypes.func.isRequired,
    restoreState: PropTypes.func.isRequired,
    requestSelection: PropTypes.func.isRequired,
    moreFormats: PropTypes.arrayOf(
      PropTypes.shape({
        format: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        tooltip: PropTypes.arrayOf(PropTypes.string),
        moreKey: PropTypes.string,
      })
    ).isRequired,
    displayOptions: PropTypes.object,
    banner: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    spellCheck: PropTypes.bool.isRequired,
    showPrintMargins: PropTypes.bool.isRequired,
    printLayout: PropTypes.bool.isRequired,
    viewer: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    moreFormats: [],
    spellCheck: false,
    printLayout: false,
    viewer: false,
  };

  override state: ProtocolEditorState = {
    selected: {},
    atSignState: null,
    hyperlinkState: null,
    formatState: FormatState.readFormats(),
    editorWidth: 700,
    showInsertLinkModal: false,
    insertingSymbolState: null,
  };

  containerRef = React.createRef<HTMLDivElement>();
  stepsEditorRootRef = React.createRef<HTMLDivElement>();
  editorRef = React.createRef<HTMLDivElement>();

  _isMounted!: boolean;
  stepsEditorRef: StepsEditorInstance | null | undefined;

  override componentDidMount(): void {
    this._isMounted = true;
  }

  override componentWillUnmount(): void {
    window.removeEventListener('resize', this._editorSizerThrottledHandleResize);
    this._isMounted = false;
  }

  override componentDidUpdate(prevProps: ProtocolEditorProps, prevState: ProtocolEditorState): void {
    this._editorSizerHandleResize();

    maybeUpdatePrintWarningForContentWidth(
      this.state.containerWidth as number,
      this.props.displayOptions as VisibilityOptions | null
    );
  }
  _editorSizerThrottledHandleResize = throttle(() => {
    this._editorSizerHandleResize();
  }, 250);

  _editorSizerHandleResize = (): void => {
    if (
      this._isMounted &&
      isBrowser &&
      !isHeadlessChrome() &&
      this.containerRef.current != null &&
      this.editorRef.current != null
    ) {
      // In we did not guard against the non-browser environment, we'd set editorWidth to 0,
      // which results in undesired behavior when performing exports.

      const $container = $(this.containerRef.current);
      const containerWidth = $container.width();
      const containerHeight = $container.height();
      const editorWidth = $(this.editorRef.current).width();

      if (
        editorWidth !== this.state.editorWidth ||
        containerWidth !== this.state.containerWidth ||
        containerHeight !== this.state.containerHeight
      ) {
        this.setState({editorWidth, containerWidth, containerHeight});
      }
    }
  };

  openInsertLinkModal = (
    formats: Format,
    partition: {before: string; selected: string; after: string},
    editingFormatIndex: ProtocolEditorFormatLocation
  ): void => {
    this.setState({
      showInsertLinkModal: true,
      // Everything we need once the user clicks save on the edit link modal.
      editingLinkState: getEditingLinkState(formats, partition, editingFormatIndex),
    });
  };

  closeInsertLinkModal = (): void => {
    this.setState({editingLinkState: null, showInsertLinkModal: false});
  };

  openInsertSymbolModal = (
    index: ProtocolEditorFormatLocation | ProtocolEditorItemIndex,
    partition: {before: string; after: string; selected: string; afterPoint?: boolean} | null,
    formats: Format
  ): void => {
    this.setState({insertingSymbolState: {index, partition, formats}});
  };

  _closeSymbolModal = (): void => {
    this.setState({insertingSymbolState: null});
  };

  _insertSymbol = (symbol: string): void => {
    const {formats, partition, index} = this.state.insertingSymbolState!;
    const {formats: newFormats, text, end} = formatters.replaceText(formats, partition!, symbol);
    // After insert, place cursor at end of range.
    this.updateFormattedText(
      {text, start: end, end, formats: newFormats},
      index as ProtocolEditorFormatLocation
    );
    analytics.track('editor', 'inserted_symbol', {symbol});
  };

  renderInsertSymbolModal = (): JSX.Element => (
    <ModalAnchor open={this.state.insertingSymbolState != null}>
      <InsertSymbolModalClass onRequestClose={this._closeSymbolModal} onRequestSubmit={this._insertSymbol} />
    </ModalAnchor>
  );

  nestedStoreState = (key: string, data: {selection: BenchlingSelection | null}): void => {
    this.props.storeState(
      DocumentManagerComponentClass.keyData(key, data as {selection: BenchlingSelection})
    );
  };

  nestedRestoreState = (
    key: string,
    e: ElementKeyboardEvent,
    data: {selection: BenchlingSelection}
  ): boolean | void => this.props.restoreState(e, DocumentManagerComponentClass.keyData(key, data));

  nestedRequestSelection = (key: string, data: unknown): void => {
    this.props.requestSelection(
      DocumentManagerComponentClass.keyData(key, data as {selection: BenchlingSelection})
    );
  };

  isLockedWithEditWarn = (): boolean => {
    if (this.props.locked) {
      notifications.warn(this.props.banner != null ? this.props.banner : 'Editing is disabled.', {
        id: 'ProtocolEditor.isLockedWithEditWarn',
      });
    }
    return this.props.locked as boolean;
  };

  renderEditor = (
    key: StepConstants.EditorKey,
    ref: string | null,
    component: React.ElementType,
    extraProps?: Record<string, unknown>
  ): JSX.Element => {
    if (extraProps == null) {
      extraProps = {};
    }
    return (
      <IntermediateBinder<ProtocolEditorBinderProps, StepConstants.EditorKey>
        ref={ref}
        boundArg={key}
        storeState={this.nestedStoreState}
        restoreState={this.nestedRestoreState}
        requestSelection={this.nestedRequestSelection}
        formatHandler={this._formatHandler}
      >
        {(boundProps) =>
          React.createElement(component, {
            highlightIndex: key === this.state.highlightEditorKey ? this.state.highlightIndex : undefined,
            insertIndex: key === this.state.insertEditorKey ? this.state.insertIndex : undefined,
            protocol: this.props.protocol,
            locked: this.props.locked,
            spellCheck: this.props.spellCheck,
            updateProtocol: this.props.updateProtocol,
            metadataForRestore: DocumentManagerComponentClass.unkeyData(
              key,
              this.props.metadataForRestore as KeyData
            ),
            jumpTo: this.jumpTo,
            editorKey: key,
            isLockedWithEditWarn: this.isLockedWithEditWarn,
            viewer: this.props.viewer,
            ...boundProps,
            ...extraProps,
          })
        }
      </IntermediateBinder>
    );
  };

  setStepsEditorRef = (stepsEditor: StepsEditorInstance | null): void => {
    this.stepsEditorRef = stepsEditor;
  };

  getStepsEditor = (): StepsEditorInstance | null | undefined => this.stepsEditorRef;

  jumpTo = ({
    section,
    row,
    location,
  }: {
    section: StepConstants.EditorKey | string;
    row?: 'first' | 'last' | string;
    location: 'start' | 'end' | string;
  }): void => {
    function selectionFor(cid: string, text: string): {selection: BenchlingSelection} {
      const pos = location === 'start' ? 0 : text.length;
      return {selection: {cid, start: pos, end: pos}};
    }

    let selection: {selection: BenchlingSelection} | ReturnType<StepsEditorInstance['selectionAtStart']>;
    let item: MaterialsEditorMaterial | MaterialsEditorMaterial['components'][number] | undefined;
    let text: string | undefined;

    switch (section) {
      case EditorKey.TITLE:
        selection = selectionFor(this.getTitleCid(), this.props.protocol.name!);
        break;
      case EditorKey.INTRO:
        selection = selectionFor(this.getIntroCid(), this.props.protocol.description!);
        break;
      case EditorKey.STEPS: {
        const firstStep = this.props.protocol.steps![0];
        const lastStep = this.props.protocol.steps![this.props.protocol.steps!.length - 1];
        const step = row === 'first' ? firstStep : lastStep;
        selection =
          location === 'start'
            ? this.getStepsEditor()!.selectionAtStart(step)
            : this.getStepsEditor()!.selectionAtEnd(step);
        break;
      }
      case EditorKey.MATERIALS:
        if (row === 'first') {
          [item] = Array.from(this.props.protocol.materials!);
          text = item.name;
        } else {
          item = this.props.protocol.materials![this.props.protocol.materials!.length - 1];
          text = item.name;
          if (item.components.length) {
            item = item.components[item.components.length - 1];
            text = item.raw_text;
          }
        }
        selection = selectionFor(item.cid, text);
        break;
      default:
        logging.warn('Invalid section for ProtocolEditor.jumpTo:', section as never);
        return;
    }
    this.nestedRequestSelection(section, selection);
  };

  _handleOpenInsertSymbolModalForProtocolSection = (
    editorKey: StepConstants.EditorKey | string,
    index: ProtocolEditorItemIndex
  ): void => {
    const formats = ((): Format => {
      switch (editorKey) {
        case EditorKey.STEPS:
          return (this.atIndex(editorKey, index as number) as StepConstants.Step).formats;
        case EditorKey.MATERIALS: {
          const item = this.atIndex(editorKey, index as MaterialIndex) as NonNullable<
            ReturnType<typeof ProtocolStoreTransforms.getMaterialByIndex>
          >;
          if (item.level === LEVEL_MATERIAL) {
            return item.material.formats;
          } else {
            return item.component.formats;
          }
        }
        case EditorKey.INTRO:
          return this.props.protocol.descriptionFormats!;
        default:
          throw new Error(`Unexpected editor key: ${editorKey}`);
      }
    })();
    const partition = StaticFormatToolbarClass.getPartition(this.getEditor(), this.state.selected);
    this.openInsertSymbolModal({editorKey, index}, partition, formats);
  };

  _formatHandler = (
    editorKey: StepConstants.EditorKey | string,
    index: ProtocolEditorItemIndex,
    e: ProtocolEditorFormatEvent
  ): void => {
    if (e.format === FormattersConstants.SYMBOL) {
      this._handleOpenInsertSymbolModalForProtocolSection(editorKey, index);
      return;
    }

    const parentFormat = _.findWhere(this.props.moreFormats, {format: e.format});
    if (parentFormat != null) {
      parentFormat.onClick();
      return;
    }
    this.nestedStoreState(editorKey, {selection: selutil.getSelectionIndices()});
    switch (editorKey) {
      case EditorKey.MATERIALS:
        this._formatHandlerMaterials(index as MaterialIndex, e);
        return;
      case EditorKey.INTRO:
        this._formatHandlerIntro(index, e);
        return;
      case EditorKey.STEPS:
        this._formatHandlerSteps(index as number, e);
        return;
      default:
        throw new Error(`Unexpected editor key: ${editorKey}`);
    }
  };

  _toolbarFormatHandler = (format: string, data?: ProtocolEditorFormatEvent['data']): void => {
    const {editorKey, index} = this.state.selected;
    const partition = StaticFormatToolbarClass.getPartition(this.getEditor(), this.state.selected);
    this._formatHandler(editorKey!, index!, {format, data, partition});
  };

  processIndexStr = (editorKey: string, index: string): ProtocolEditorItemIndex => {
    if (editorKey === EditorKey.MATERIALS) {
      return index.split(',').map((part) => parseInt(part, 10)) as MaterialIndex;
    }
    return parseInt(index, 10);
  };

  getIntroCid = (): string => `${this.props.protocol.cid}-intro`;

  getTitleCid = (): string => `${this.props.protocol.cid}-title`;

  atIndex = (
    editorKey: StepConstants.EditorKey | string,
    index: ProtocolEditorItemIndex
  ): StepConstants.Step | NonNullable<ReturnType<typeof ProtocolStoreTransforms.getMaterialByIndex>> => {
    switch (editorKey) {
      case EditorKey.STEPS:
        return this.props.protocol.steps![index as number];
      case EditorKey.MATERIALS:
        // The materials editor path is only reachable for protocols with an inline materials collection.
        return ProtocolStoreTransforms.getMaterialByIndex(
          this.props.protocol as MaterialsEditorProtocol,
          index as [number, number?]
        )!;
      // We don't (currently) expect to get EditorKey.INTRO
      default:
        throw new Error(`Unexpected editor key: ${editorKey}`);
    }
  };

  _toolbarInsertItemHandler = (type: string): void => {
    const {editorKey, index} = this.state.selected;
    if (type === INSERT_SYMBOL) {
      this._handleOpenInsertSymbolModalForProtocolSection(editorKey!, index!);
      return;
    }

    if (editorKey === EditorKey.STEPS) {
      let item = null;
      switch (type) {
        case StepLevel.HEADER:
        case StepLevel.STEP:
        case StepLevel.DESC:
          item = ProtocolStoreTransforms.makeStep('', formatters.defaultFormats(), type);
          break;
        case StepLevel.IMAGE:
          item = ProtocolStoreTransforms.makeImage();
          break;
        case StepLevel.TIMER:
          item = ProtocolStoreTransforms.makeTimer();
          break;
        case StepLevel.TABLE:
          item = this._makeTableItem(DEFAULT_TABLE_SIZE[0], DEFAULT_TABLE_SIZE[1]);
          break;
        case INSERT_WELL_PLATE:
          item = this._makeTableItem(DEFAULT_PLATE_SIZE[0], DEFAULT_PLATE_SIZE[1], {isWellPlate: true});
          break;
        default:
          throw new Error(`Unexpected type ${type} for editor key ${editorKey}`);
      }
      const steps = reactUpdate(
        this.props.protocol.steps as Array<StepConstants.Step>,
        // The factories return the runtime store shape, which is narrower than the shared Step model.
        {
          $splice: [[(index as number) + 1, 0, item]],
        } as never
      );
      this.props.updateProtocol!({steps});
    } else {
      throw new Error(`Unexpected type ${type} for editor key ${editorKey}`);
    }
  };

  _insertTableOrWellPlate = (rows: number, cols: number, isWellPlate: boolean): void => {
    const tableItem = this._makeTableItem(rows, cols, {isWellPlate});
    const steps = reactUpdate(
      this.props.protocol.steps as Array<StepConstants.Step>,
      // The table factory returns the runtime store shape, which is narrower than the shared Step model.
      {
        $splice: [[(this.state.selected.index as number) + 1, 0, tableItem]],
      } as never
    );
    this.props.updateProtocol!({steps});
  };

  insertTableWithDimensions = (rows: number, cols: number): void => {
    this._insertTableOrWellPlate(rows, cols, false);
  };

  insertWellPlateWithDimensions = (rows: number, cols: number): void => {
    this._insertTableOrWellPlate(rows, cols, true);
  };

  _makeTableItem = (
    rows: number,
    cols: number,
    param?: {isWellPlate?: boolean}
  ): ReturnType<typeof ProtocolStoreTransforms.makeTable> => {
    if (param == null) {
      param = {};
    }
    const {isWellPlate} = param;
    const usedTableNames = Array.from(this.props.protocol.steps as Array<StepConstants.Step>)
      .filter((s) => s.level === StepLevel.TABLE)
      .map((s) => s.table!.name);
    const tableName = excessutil.uniqueTableName(
      usedTableNames,
      isWellPlate ? TABLE_NAME_WELL_PREFIX : undefined
    );
    return ProtocolStoreTransforms.makeTable(tableName, null, rows, cols, {
      isWellPlate,
    } as {isWellPlate: boolean});
  };

  updateFormattedText = (
    {formats, text, start, end}: {formats: Format; text: string; start: number; end: number},
    {editorKey, index}: ProtocolEditorFormatLocation
  ): void => {
    let newMaterial: MaterialsEditorMaterial;
    switch (editorKey) {
      case EditorKey.INTRO:
        this.props.updateProtocol!({descriptionFormats: formats, description: text});
        this.nestedRequestSelection(EditorKey.INTRO, {selection: {start, end, cid: this.getIntroCid()}});
        break;
      case EditorKey.MATERIALS: {
        const item = this.atIndex(editorKey, index as MaterialIndex) as NonNullable<
          ReturnType<typeof ProtocolStoreTransforms.getMaterialByIndex>
        >;
        if (item.level === LEVEL_MATERIAL) {
          newMaterial = reactUpdate(item.material, {$merge: {formats, name: text}});
        } else {
          const newComponent = reactUpdate(item.component, {$merge: {formats, raw_text: text}});
          newMaterial = reactUpdate(item.material, {
            components: {
              $merge: _.object<Record<number, MaterialsEditorComponent>>([
                [(index as MaterialIndex)[1], newComponent],
              ]),
            },
          });
        }
        const {materials} = this.props.protocol;
        const newMaterials = reactUpdate(materials as Array<MaterialsEditorMaterial>, {
          $merge: _.object<Record<number, MaterialsEditorMaterial>>([
            [(index as MaterialIndex)[0], newMaterial],
          ]),
        });
        this.props.updateProtocol!({materials: newMaterials});
        this.nestedRequestSelection(EditorKey.MATERIALS, {selection: {cid: item.model.cid, start, end}});
        return;
      }
      case EditorKey.STEPS: {
        const item = this.atIndex(editorKey, index as number) as StepConstants.Step;
        const selection = {start, end, cid: item.cid};
        const $merge = {formats, text};
        this.updateSteps(index as number, $merge, selection);
        break;
      }
      default:
        throw new Error(`Unexpected error key: ${editorKey}`);
    }
  };

  _formatHandlerMaterials = (index: MaterialIndex, e: ProtocolEditorFormatEvent): void => {
    const item = this.atIndex(EditorKey.MATERIALS, index) as NonNullable<
      ReturnType<typeof ProtocolStoreTransforms.getMaterialByIndex>
    >;
    formatText(
      item.model.formats,
      {
        format: e.format,
        data: e.data,
        partition: e.partition ?? null,
      },
      {editorKey: EditorKey.MATERIALS, index},
      this.openInsertLinkModal,
      this.updateFormattedText
    );
  };

  _formatHandlerIntro = (index: ProtocolEditorItemIndex, e: ProtocolEditorFormatEvent): void => {
    formatText(
      this.props.protocol.descriptionFormats!,
      {
        format: e.format,
        data: e.data,
        partition: e.partition ?? null,
      },
      {editorKey: EditorKey.INTRO, index},
      this.openInsertLinkModal,
      this.updateFormattedText
    );
  };

  updateSteps = (index: number, $merge: object, selection: BenchlingSelection | null): void => {
    const steps = reactUpdate(
      this.props.protocol.steps as Array<StepConstants.Step>,
      _.object([[index, {$merge}]])
    );
    this.props.updateProtocol!({steps});
    this.nestedRequestSelection(EditorKey.STEPS, {selection});
  };

  _formatHandlerSteps = (index: number, e: ProtocolEditorFormatEvent): void => {
    const {format} = e;
    let item = this.atIndex(EditorKey.STEPS, index) as StepConstants.Step;
    if (format === 'delete') {
      this.nestedStoreState(EditorKey.STEPS, {selection: {cid: item.cid, start: 0, end: 0}});
      let selection: BenchlingSelection | null = null;
      if (index > 0) {
        item = this.atIndex(EditorKey.STEPS, index - 1) as StepConstants.Step;
        if (item.text != null) {
          // TODO(eln): Make StepEditor.getPluginByItem work to generalize
          selection = {cid: item.cid, start: item.text.length, end: item.text.length};
        }
      } else if (this.props.protocol.steps!.length > 1) {
        item = this.atIndex(EditorKey.STEPS, 1) as StepConstants.Step;
        if (item.text != null) {
          selection = {cid: item.cid, start: 0, end: 0};
        }
      }

      const steps = reactUpdate(
        this.props.protocol.steps as Array<StepConstants.Step>,
        // Immutability-helper cannot reconcile its recursive spec with this legacy Step union.
        {
          $splice: [[index, 1]],
        } as never
      );
      this.props.updateProtocol!({steps});
      if (selection != null) {
        this.nestedRequestSelection(EditorKey.STEPS, {selection});
      }
      return;
    }

    switch (format) {
      case AGGREGATE_TIME: {
        const $merge = {time_seconds: item.time_seconds ? null : 10 * 60};
        this.updateSteps(index, $merge, selutil.getSelectionIndices());
        break;
      }
      case TYPE_CRITICAL:
      case TYPE_PAUSE: {
        const type = item.type === format ? null : format;
        this.updateSteps(index, {type}, selutil.getSelectionIndices());
        break;
      }
      case StepLevel.HEADER:
      case StepLevel.STEP:
      case StepLevel.DESC:
        this.updateSteps(index, {level: format}, selutil.getSelectionIndices());
        break;
      default:
        formatText(
          item.formats,
          {
            format: e.format,
            data: e.data,
            partition: e.partition ?? null,
          },
          {editorKey: EditorKey.STEPS, index},
          this.openInsertLinkModal,
          this.updateFormattedText
        );
    }
  };

  _toolbarMouseOverHandler = (fmt: string): void => {
    const {editorKey, index} = this.state.selected;
    if ((editorKey === EditorKey.STEPS && STEP_FORMATS.includes(fmt)) || fmt === 'delete') {
      this.setState({highlightEditorKey: editorKey, highlightIndex: index});
    }
  };

  _toolbarInsertMouseOverHandler = (): void => {
    const {editorKey, index} = this.state.selected;
    this.setState({insertIndex: index, insertEditorKey: editorKey});
  };

  _toolbarInsertMouseOutHandler = (): void => {
    this.setState({insertIndex: null, insertEditorKey: null});
  };

  _toolbarMouseOutHandler = (): void => {
    this.setState({highlightIndex: null, highlightEditorKey: null});
  };

  getEditor = (): HTMLDivElement | null => this.editorRef.current;

  onMouseDownCatcher = (e: ElementMouseEvent): void => {
    if (this.props.locked) {
      return;
    }
    if (
      ![this.editorRef.current, this.stepsEditorRootRef.current].includes(e.target as HTMLDivElement | null)
    ) {
      return;
    }

    e.preventDefault();
    const $steps = $(this.stepsEditorRootRef.current!).find('.mediocre-item');
    const maxStepY = _.max($steps.get().map((step) => $(step).offset()!.top + $(step).height()));
    if (e.pageY <= maxStepY) {
      return;
    }

    const lastStep = this.props.protocol.steps![this.props.protocol.steps!.length - 1];

    if (lastStep != null && this.getStepsEditor()!.isItemTextual(lastStep)) {
      this.nestedRequestSelection(EditorKey.STEPS, this.getStepsEditor()!.selectionAtEnd(lastStep));
      return;
    }

    const item = ProtocolStoreTransforms.makeStep('', formatters.defaultFormats(), StepLevel.STEP);
    const steps = reactUpdate(
      this.props.protocol.steps as Array<StepConstants.Step>,
      // The step factory returns the runtime store shape, which is narrower than the shared Step model.
      {$push: [item]} as never
    );
    this.props.updateProtocol!({steps});
    this.nestedRequestSelection(
      EditorKey.STEPS,
      this.getStepsEditor()!.selectionInit(item as StepConstants.Step)
    );
  };

  handleChangeSelected = (value: ProtocolEditorSelected): void => {
    this.setState({selected: value});
  };

  handleChangeFormatState = (value: ProtocolEditorState['formatState']): void => {
    this.setState({formatState: value});
  };

  handleChangeAtSignState = (value: SignState | null): void => {
    this.setState({atSignState: value});
  };

  handleChangeSlashSignState = (value: SignState | null): void => {
    this.setState({slashSignState: value});
  };

  handleChangeHyperlinkState = (value: HyperlinkState | null): void => {
    this.setState({hyperlinkState: value});
  };

  handleChangeNonEmptySelectionState = (value: ProtocolEditorState['nonEmptySelectionState']): void => {
    this.setState({nonEmptySelectionState: value});
  };

  override render(): JSX.Element {
    const {editorKey, index, hasNonEmptyTextSelection} = this.state.selected;
    const stepItem =
      editorKey === EditorKey.STEPS
        ? (this.atIndex(editorKey, index as number) as StepConstants.Step)
        : undefined;
    return (
      <div className="protocolEditor">
        {/* Use a DIV container to prevent modals's <noscript> from causing a large reflow */}
        <div>
          <EditLinkModal
            fileId={this.props.fileId}
            showInsertLinkModal={this.state.showInsertLinkModal}
            editingLinkState={this.state.editingLinkState}
            closeInsertLinkModal={this.closeInsertLinkModal}
            updateFormattedText={this.updateFormattedText}
          />
          {this.renderInsertSymbolModal()}
        </div>
        {this.props.showToolbar ? (
          <BufferOptions
            leftChildren={React.createElement(
              BufferOptionsItem,
              {key: 'toolbar'},
              <ProtocolToolbar
                formatState={this.state.formatState}
                mouseOverHandler={this._toolbarMouseOverHandler}
                mouseOutHandler={this._toolbarMouseOutHandler}
                insertMouseOverHandler={this._toolbarInsertMouseOverHandler}
                insertMouseOutHandler={this._toolbarInsertMouseOutHandler}
                insertHandler={this._toolbarInsertItemHandler}
                insertTableWithDimensions={this.insertTableWithDimensions}
                insertWellPlateWithDimensions={this.insertWellPlateWithDimensions}
                formatHandler={this._toolbarFormatHandler}
                locked={this.props.locked!}
                stepLevel={stepItem != null ? stepItem.level : undefined}
                stepType={stepItem != null ? stepItem.type : undefined}
                stepHasTime={stepItem != null && stepItem.time_seconds! > 0}
                editorKey={editorKey}
                printOptions={this.props.printOptions!}
                printHandler={this.props.printHandler}
                moreFormats={this.props.moreFormats}
                hasNonEmptyTextSelection={hasNonEmptyTextSelection || false}
              />
            )}
            banner={this.props.banner}
            rightChildren={[
              !this.props.protocol.inEntry &&
              (this.props.protocol.permissions != null
                ? this.props.protocol.permissions.readable
                : undefined) ? (
                <BufferOptionsItem key="protocol-link">
                  <a
                    className="u-no-text-decoration u-bold-font-weight"
                    href={this.props.protocol.url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {'Discuss '}
                    <BenchlingIcon icon="arrow-up-right-from-square" />
                  </a>
                </BufferOptionsItem>
              ) : undefined,
              this.props.displayOptions != null ? (
                <BufferOptionsItem className="u-vertical-center-items" key="display-options">
                  <DisplayOptions dropLeft={true} options={this.props.displayOptions} />
                </BufferOptionsItem>
              ) : undefined,
            ]}
          />
        ) : undefined}
        <div
          ref={this.containerRef}
          className={classNames('protocolEditor-pageContainer', {'is-printLayout': this.props.printLayout})}
        >
          {this.state.hyperlinkState != null ? (
            <PositionedLinkPopover
              hyperlinkState={this.state.hyperlinkState}
              onChange={() => {
                this._toolbarFormatHandler(FormattersConstants.LINK);
              }}
              onRemove={(e) => {
                this._toolbarFormatHandler(FormattersConstants.SET_LINK, {url: null});
              }}
              containerWidth={this.state.containerWidth!}
            />
          ) : undefined}

          <div className="protocolEditor-page">
            <div
              ref={this.editorRef}
              className="protocolEditor-contentWrapper"
              onMouseDown={this.onMouseDownCatcher}
            >
              {this.renderEditor(EditorKey.TITLE, null, TitleEditorClass, {
                cid: this.getTitleCid(),
              })}
              <SelectionReader
                selected={this.state.selected as React.ComponentProps<typeof SelectionReader>['selected']}
                onChangeSelected={
                  this.handleChangeSelected as React.ComponentProps<
                    typeof SelectionReader
                  >['onChangeSelected']
                }
                formatState={this.state.formatState}
                onChangeFormatState={this.handleChangeFormatState}
                atSignState={this.state.atSignState!}
                onChangeAtSignState={this.handleChangeAtSignState}
                hyperlinkState={this.state.hyperlinkState!}
                onChangeHyperlinkState={this.handleChangeHyperlinkState}
                // SelectionReader types processIndex/selected as number; materials use comma-split tuples.
                processIndex={this.processIndexStr as (editorKey: string, index: string) => number}
                scrollableParentSelector=".protocolEditor-pageContainer"
                slashSignState={this.state.slashSignState!}
                onChangeSlashSignState={this.handleChangeSlashSignState}
                nonEmptySelectionState={this.state.nonEmptySelectionState!}
                onChangeNonEmptySelectionState={this.handleChangeNonEmptySelectionState}
              >
                <div>
                  <h2>Introduction</h2>
                  {this.renderEditor(EditorKey.INTRO, null, IntroEditorClass, {
                    cid: this.getIntroCid(),
                  })}
                  <h2>Materials</h2>
                  {this.renderEditor(EditorKey.MATERIALS, null, MaterialsEditorClass)}
                  <h2>Procedure</h2>
                  {this.renderEditor(EditorKey.STEPS, 'stepsEditorBinder', StepsEditorContainer, {
                    setRef: this.setStepsEditorRef,
                    rootRef: this.stepsEditorRootRef,
                    fileId: this.props.fileId,
                    openManageSelectorsModal: this.props.openManageSelectorsModal,
                    printLayout: this.props.printLayout,
                  })}
                </div>
              </SelectionReader>
              {this.props.showPrintMargins ? (
                <div>
                  <div className="mediocre-pageMargin mediocre-pageMargin--left" />
                  <div className="mediocre-pageMargin mediocre-pageMargin--right" />
                </div>
              ) : undefined}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProtocolEditor;
